import React from 'react'
import { useIntl } from 'react-intl'
import StructureLabel from 'LuxKit/Label/StructureLabel'

interface Props {
  className?: string
}

/**
 * Bundle discount badge for Maldives flight + hotel bundles.
 *
 * Displayed when a charter flight is purchased with a Maldives hotel,
 * indicating the 15% flight markup has been removed.
 */
function MaldivesBundleDiscountBadge({ className }: Props) {
  const intl = useIntl()

  return (
    <StructureLabel
      variant="maldives-charter"
      className={className}
      data-testid="maldives-bundle-discount-badge"
    >
      {intl.formatMessage({
        id: 'IDu8hPbakjH4ltR1rmVo',
        defaultMessage: 'Bundle discount',
        description: 'Badge label for Maldives flight + hotel bundle discount',
      })}
    </StructureLabel>
  )
}

export default MaldivesBundleDiscountBadge
